angular.module('admin')
.controller('AdminInviteController', ['$scope', '$uibModal', '$timeout', 'Notification', 'ModalHandler', 'ProviderInvitation', 'Logger', 'Practice', 'Auth', 'Address',
    function ($scope, $uibModal, $timeout, Notification, ModalHandler, ProviderInvitation, Logger, Practice, Auth, Address) {
        $scope.invitedUsers = [];
        $scope.invitedColleagues = [];
        $scope.searchCollapsed = true;

        Practice.getAllInvitees({id: $scope.$parent.auth.practice_id}, function(allInvitees) {
            allInvitees.map(function(invitation) {
                if (invitation.roles_mask) {  // criteria to tell user invitations apart from colleague invitations
                    $scope.invitedUsers.push(invitation);
                } else {
                    $scope.invitedColleagues.push(invitation);
                }
            });
        });

        $scope.searchAddresses = function(searchPhrase) {
            $scope.noResults = false;
            Address.search({search: searchPhrase}, function(result) {
                $scope.addresses = result;
                $scope.searchCollapsed = false;
                if (result.length < 1) {
                    $scope.noResults = true;
                }

            })
        };

        $scope.inviteDialog = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/provider_form.html',
                controller: 'ProviderModalController',
                resolve: {
                    dependsOnReferral: function() {
                        return false;
                    },
                    inviterId: function() {
                        return Auth.getOrRedirect().id;
                    }
                }
            });
            ModalHandler.set(modalInstance);
            modalInstance.result.then(function (result) {
                var provider = result.provider;

                var newModalInstance = $uibModal.open({
                    templateUrl: 'partials/invite_practice_result.html',
                    controller: 'InvitePracticeResultController',
                    resolve: {
                        toEmail: function() {
                            return provider.email;
                        }
                    }
                });
                ModalHandler.set(newModalInstance);
                
                $scope.invitedColleagues.push(provider);
            }).catch(function () {
                Logger.log('Modal dismissed');
            });
        };

        $scope.resendInvitation = function(id) {
            ProviderInvitation.resend({id: id}, function(success) {
                Notification.success("Invitation sent successfully");
            });
        };

        // loading map with practices
        function getMapElement() {
            return document.getElementById('practices-map');
        }

        function markerInfoHtml(feature) {
            var name = feature.getProperty("name");
            var type = feature.getProperty("type");
            var address = feature.getProperty("address");
            return `
            <ul class="marker-info">
                <li class="name">${name}</li>
                <li class="type">${type}</li>
                <li class="address">${address}</li>
            </ul>
            `;
        }

        $scope.initMap = function() {
            let mapElement = getMapElement();

            const USA_BOUNDS = {
                north: 49.38,
                south: 25.82,
                west: -124.39,
                east: -66.94,
            };

            $scope.map = new google.maps.Map(mapElement, {
                zoom: 3,
                center: { lat: 37.60, lng: -95.66 },
                restriction: {
                    latLngBounds: USA_BOUNDS,
                    strictBounds: false,
                }
            });

            // NOTE: This uses cross-domain XHR, and may not work on older browsers.
            $scope.map.data.loadGeoJson(
                "/practices/geo_json"
            );

            var infowindow = new google.maps.InfoWindow();

            // When the user clicks, open an infowindow
            $scope.map.data.addListener('click', function(event) {
                let feature = event.feature;
                infowindow.setContent("<div style='width:150px;'>" + markerInfoHtml(feature) + "</div>");
                // position the infowindow on the marker
                infowindow.setPosition(feature.getGeometry().get());
                // anchor the infowindow on the marker
                infowindow.setOptions({pixelOffset: new google.maps.Size(0,-30)});
                infowindow.open($scope.map);
            });
        }
   
        $scope.loadMapScript = function() {
            // todo: move into a service to prevent double loading Google Maps API script.
            if (!$scope.map && getMapElement()) {
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAZRhUYj0BICpRYrzz09wynSPVRFBA3DbU&v=weekly';
                document.body.appendChild(script);
    
                $timeout(function() {
                    $scope.initMap();
                }, 500);
            }
        }
    }]);